import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import { EmailAddress, ForgotPassword, Password, RememberPassword, SignIn } from "../Constant";

import { useNavigate } from "react-router-dom";
import man from "../assets/images/dashboard/profile.png";

import CustomizerContext from "../_helper/Customizer";
import AdminContext from "../_helper/Admin";
import OtherWay from "./OtherWay";
import { ToastContainer, toast } from "react-toastify";

const Signin = ({ selected }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const { login, loading, error, isAuthenticated } = useContext(AdminContext);

  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(localStorage.getItem("Name"));

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      history(`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`);
    }
  }, [isAuthenticated, history, layoutURL]);

  const loginAuth = async (e) => {
    e.preventDefault();

    // Validate input
    if (!email || !password) {
      toast.error("Vui lòng nhập email và password");
      return;
    }

    // Real API login with admin.js
    try {
      const result = await login(email, password);
      
      // Save user info to localStorage
      if (result.admin) {
        setValue(man);
        setName(result.admin.name || "Admin User");
        localStorage.setItem("profileURL", man);
        localStorage.setItem("Name", result.admin.name || "Admin User");
        localStorage.setItem("login", JSON.stringify(true));
      }

      toast.success("Đăng nhập thành công!");
      history(`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`);
    } catch (err) {
      console.error("Login error:", err);
      toast.error(err.message || "Đăng nhập thất bại. Vui lòng kiểm tra thông tin đăng nhập.");
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="p-0 login-page">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form" onSubmit={loginAuth}>
                  <H4>{selected === "simpleLogin" ? "" : "Sign In With Simple Login"}</H4>
                  <P>{"Enter your email & password to login"}</P>
                  <FormGroup>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input className="form-control" type="text" onChange={(e) => setEmail(e.target.value)} value={email} />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">{Password}</Label>
                    <div className="position-relative">
                      <Input className="form-control" type={togglePassword ? "text" : "password"} onChange={(e) => setPassword(e.target.value)} value={password} />
                      <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                        <span className={togglePassword ? "" : "show"}></span>
                      </div>
                    </div>
                  </FormGroup>
                  <div className="position-relative form-group mb-0">
                    <div className="checkbox">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" for="checkbox1">
                        {RememberPassword}
                      </Label>
                    </div>
                    <a className="link" href="#javascript">
                      {ForgotPassword}
                    </a>
                    <Btn attrBtn={{ color: "primary", className: "d-block w-100 mt-2", type: "submit", disabled: loading }}>
                      {loading ? "Signing in..." : SignIn}
                    </Btn>
                    {error && <div className="text-danger mt-2 small">{error}</div>}
                  </div>
                  {/* <OtherWay /> */}
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;
